"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ConditionalHelper_1 = require("./ConditionalHelper");

var replacePlaceholders_1 = require("../utils/replacePlaceholders");

var isArrayLike_1 = require("../utils/isArrayLike");

var utils_1 = require("../utils");

var typeChecks_1 = require("../utils/typeChecks");

var collection_1 = require("../utils/collection");

var RedirectHelper =
/** @class */
function () {
  function RedirectHelper(url, base) {
    if (!base) {
      base = window && window.location.origin;
    }

    this.url = new URL(url, base);
  }

  RedirectHelper.prototype.go = function (redirect, inputs) {
    var options = redirect.options;
    var redirectPath = this.getRedirectPath(redirect, inputs);

    if (redirectPath) {
      if (options && options.target) {
        window.open(redirectPath, options.target);
      } else {
        document.location.href = redirectPath;
      }
    }
  };

  RedirectHelper.prototype.getRedirectPath = function (redirect, inputs) {
    if (redirect) {
      var conditionalRedirects = redirect.conditionalRedirects,
          defaultUrl = redirect.defaultUrl,
          base = redirect.base,
          _a = redirect.options,
          options = _a === void 0 ? {} : _a;
      var validRedirect = void 0;

      if (conditionalRedirects) {
        validRedirect = conditionalRedirects.find(function (conditionalRedirect) {
          var conditional = conditionalRedirect.conditional;
          var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional);
          return conditionalHelper.matches(inputs);
        });
      }

      var url = validRedirect && validRedirect.url || defaultUrl;
      var redirectOptions = validRedirect && validRedirect.options || options;
      var replacedUrl = replacePlaceholders_1.replacePlaceholders(inputs || {}, url);
      return this.getRedirectUrl(replacedUrl, base, redirectOptions, inputs);
    }
  };

  RedirectHelper.prototype.getRedirectUrl = function (redirectString, redirectBase, options, inputs) {
    var base = options.preserveOrigin ? this.url.origin : redirectBase;
    var redirectUrl = new URL(redirectString, base || window && window.location.origin);
    this.updatePathname(redirectUrl, options, inputs);
    this.updateSearchQueryString(redirectUrl, options, inputs);
    this.updateHash(redirectUrl, options);
    return redirectUrl.toString();
  };

  RedirectHelper.prototype.updatePathname = function (redirectUrl, options, inputs) {
    var redirectPathSegments = [];
    var paramCaseOptions = Object.assign({
      apply: false,
      separator: '-'
    }, options.paramCase); // prepend path with origin path

    if (options.preserveOriginPath) {
      var originUrlSegments = this.url.pathname.split('/');
      redirectPathSegments.push.apply(redirectPathSegments, originUrlSegments);
    } // apply pathname derived from static redirect pathname


    redirectPathSegments.push.apply(redirectPathSegments, redirectUrl.pathname.split('/')); // append dynamic pathname

    if (isArrayLike_1.isArrayLike(options.urlParams) && options.urlParams.length > 0) {
      var dynamicPathSegments = this.replacePlaceholdersOnCollection(options.urlParams, inputs);
      redirectPathSegments.push.apply(redirectPathSegments, this.applyParamCaseToCollection(dynamicPathSegments, paramCaseOptions));
    } // finally append dynamic endpoint


    if (options.urlEndpoint && isArrayLike_1.isArrayLike(options.urlEndpoint) && options.urlEndpoint.length > 0) {
      var endpointValues = options.urlEndpoint;
      var endpointSegments = this.replacePlaceholdersOnCollection(endpointValues, inputs);
      var endpoint = this.applyParamCaseToCollection(endpointSegments, paramCaseOptions).join(paramCaseOptions.separator);
      redirectPathSegments.push(endpoint);
    } // merge pathname segments to save final pathname


    var reducedPathSegments = redirectPathSegments.reduce(function (segments, segment, segmentIndex) {
      if (segment !== '' && (segmentIndex === 0 || segmentIndex > 0 && redirectPathSegments[segmentIndex - 1] !== segment)) {
        segments.push(segment);
      }

      return segments;
    }, []); // save

    redirectUrl.pathname = reducedPathSegments.join('/');
  };

  RedirectHelper.prototype.updateSearchQueryString = function (redirectUrl, options, inputs) {
    var redirectSearchParamsSegments = this.getSearchParamsSegments(redirectUrl); // override origin with static redirect search params

    if (options.preserveOriginQueryString) {
      var originSearchParams = this.getSearchParamsSegments(this.url);
      redirectSearchParamsSegments = Object.assign({}, originSearchParams, redirectSearchParamsSegments);
    } // override static redirect with dynamic search params


    if (isArrayLike_1.isArrayLike(options.queryStringParams) && options.queryStringParams.length > 0) {
      var dynamicSearchParams = options.queryStringParams.reduce(function (params, param) {
        var replacedValue = replacePlaceholders_1.replacePlaceholders(inputs || {}, param.value);

        if (!param.optional || param.optional && !typeChecks_1.isNullOrEmpty(replacedValue)) {
          params[param.key] = replacedValue;
        }

        return params;
      }, {});
      redirectSearchParamsSegments = Object.assign({}, redirectSearchParamsSegments, dynamicSearchParams);
    } // save search params segments


    var searchParamString = this.getSearchParamsString(redirectSearchParamsSegments);

    if (searchParamString) {
      redirectUrl.search = searchParamString;
    }
  };

  RedirectHelper.prototype.updateHash = function (redirectUrl, options) {
    if (!redirectUrl.hash && options.preserveOriginHash) {
      redirectUrl.hash = this.url.hash;
    }
  };

  RedirectHelper.prototype.applyParamCaseToCollection = function (collection, options) {
    if (options.apply) {
      return collection.map(function (value) {
        return utils_1.changeCase.paramCase(value, {
          delimiter: options.separator
        });
      });
    }

    return collection;
  };

  RedirectHelper.prototype.replacePlaceholdersOnCollection = function (collection, inputs) {
    var updatedCollection = collection;

    if (inputs) {
      updatedCollection = updatedCollection.map(function (value) {
        return replacePlaceholders_1.replacePlaceholders(inputs || {}, value);
      });
    }

    return collection_1.filterOutEmpty(updatedCollection);
  };

  RedirectHelper.prototype.getSearchParamsString = function (searchParams) {
    var paramKeys = Object.keys(searchParams);

    if (paramKeys.length > 0) {
      var params = paramKeys.map(function (key) {
        return !typeChecks_1.isNullOrEmpty(searchParams[key]) ? key + "=" + searchParams[key] : key;
      });
      return "?" + params.join('&');
    }

    return;
  };

  RedirectHelper.prototype.getSearchParamsSegments = function (url) {
    var params = {};

    if (url && url.search) {
      var questionMarkStripped = url.search.replace('?', '');

      if (questionMarkStripped) {
        var paramSegments = questionMarkStripped.split('&');

        if (paramSegments) {
          params = paramSegments.reduce(function (params, param) {
            var paramParts = param.split('=');

            if (paramParts[0]) {
              params[paramParts[0]] = paramParts[1] && decodeURI(paramParts[1]) || undefined;
            }

            return params;
          }, {});
        }
      }
    }

    return params;
  };

  return RedirectHelper;
}();

exports.RedirectHelper = RedirectHelper;